import React from "react"
import Text from "@/components/common/Text"

const DescriptionButton = ({ desc, color }) => {
	return <Text tag="div" className="typo-strawford typo-strawford-38 description" color={color} dangerouslySetInnerHTML={desc} />
}

export default DescriptionButton
